<template>
  <table width="98%" border="0" cellpadding="0" cellspacing="0">
    <!--DWLayoutTable-->
    <tr>
      <td width="765" height="12"></td>
    </tr>
    <tr>
      <td height="17" valign="top" class="td_hr_down">
        <!--DWLayoutEmptyCell-->&nbsp;
      </td>
    </tr>
    <tr>
      <td height="4"></td>
    </tr>
    <tr>
      <td height="14" valign="top" class="td_hr_up">
        <!--DWLayoutEmptyCell-->&nbsp;
      </td>
    </tr>
    <tr>
      <td height="35" align="center" valign="middle">
        <FONT color="#636563">::</FONT> Copyright by HKG Soonest Solutions Co.,
        Ltd. 2005 . All Right Reserved.
      </td>
    </tr>
    <tr>
      <td height="13">&nbsp;</td>
    </tr>
  </table>
</template>
<script>
export default {};
</script>